module.exports = __webpack_public_path__ + "img/rowC10.b7051b72.png";